module.exports = __webpack_public_path__ + "img/transfer.6dde5b80.svg";